module.exports = __webpack_public_path__ + "3fbfe9608126268b44d10787cd126150.png";


//////////////////
// WEBPACK FOOTER
// ./web/images/logos/brand-logo-mirimar.png
// module id = 636
// module chunks = 0